<template>
  <v-app id="noticePrivacy">
    <v-main>
      <v-container fluid fill-height>
      </v-container>
    </v-main>
    <main-footer/>
  </v-app>
</template>

<script>
import mainFooter from '@/components/Footer'

export default {
  name: 'noticePrivacy',
  components: { mainFooter },
  data: () => ({
  }),
  methods: {
    back() {
      this.$router.push('/login')
    }
  }
}
</script>

<style scoped>
</style>
